export const ADD_FACILITY_TYPES = 'entities/ADD_FACILITY_TYPES'
export const GET_FACILITY_TYPES = 'entities/GET_FACILITY_TYPES'
